import React from 'react';
import serviceData from '../data/serviceData';
import { useNavigate } from 'react-router-dom';
import WhatsAppButton from "../components/WhatsAppButton";
import { useEffect } from 'react';
import AOS from 'aos';
import { Helmet } from 'react-helmet';

const Services = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <Helmet>
        <title>Our Services | Kavipriya Associates - Tax, GST, DGFT & Compliance Services</title>
        <meta
          name="description"
          content="Comprehensive financial services including GST, Income Tax, DGFT, Customs Clearance, Book Keeping, Insurance, and Statutory Compliance. Expert services for Startups, MSMEs & Corporates."
        />
        <meta
          name="keywords"
          content="GST Services, Income Tax Services, DGFT Services, Customs Clearance, Book Keeping, Insurance Services, Statutory Compliance, MSME Subsidy, Startup Services, Tax Consultant Services"
        />
        <meta name="author" content="Kavipriya Associates" />
        <link rel="canonical" href="https://kavipriyaassociates.com/services" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Our Services | Kavipriya Associates - Complete Financial Solutions" />
        <meta
          property="og:description"
          content="Expert services in GST, Income Tax, DGFT, Customs, Book Keeping, Insurance & Compliance. Serving Startups, MSMEs & Corporates across India."
        />
        <meta property="og:image" content="https://kavipriyaassociates.com/Logo.png" />
        <meta property="og:url" content="https://kavipriyaassociates.com/services" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Our Services | Kavipriya Associates - Financial Excellence" />
        <meta
          name="twitter:description"
          content="Complete financial services: GST, Tax, DGFT, Customs, Book Keeping, Insurance & Compliance. Expert solutions for businesses."
        />
        <meta name="twitter:image" content="https://kavipriyaassociates.com/Logo.png" />
        <meta name="twitter:card" content="summary_large_image" />

        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Kavipriya Associates Services",
      "description": "Comprehensive financial and compliance services for businesses",
      "provider": {
        "@type": "Organization",
        "name": "Kavipriya Associates",
        "url": "https://kavipriyaassociates.com"
      },
      "serviceType": [
        "Tax Consulting",
        "GST Services",
        "DGFT Services",
        "Customs Clearance",
        "Book Keeping",
        "Insurance Services",
        "Statutory Compliance"
      ],
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Financial Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "GST Services"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Income Tax Services"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "DGFT Services"
            }
          }
        ]
      }
    }
    `}
        </script>
      </Helmet>

      <section className="px-4 py-20 bg-gray-100 min-h-screen">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-purple-700 mb-10">All Services</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {serviceData.map(service => (
              <div
                key={service.id}
                onClick={() => navigate(`/services/${service.id}`)}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition cursor-pointer"
              >
                <div className="text-4xl text-purple-600 mb-4">{service.icon}</div>
                <h3 className="text-lg font-semibold text-gray-800">{service.title}</h3>
              </div>
            ))}
          </div>
        </div>
        <WhatsAppButton />
      </section>
    </>
  );
};

export default Services;
